import { type } from './type.js';

/**
 * @description
 * Checks if `value` is classified as an `Array` object.
 *
 * @example
 * ``` ts
 * isArray([]);
 * // => true
 * isArray(null);
 * // => false
 * isArray(undefined);
 * // => false
 * isArray({ length: 5 });
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is an array, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-array
 */
export const isArray = (value) => {
  return Array.isArray(value) || type(value) === 'array';
};
